import { Flex, Group, Text } from '@mantine/core';

import { useConsultationLink } from '@/router/hooks/useConsolutationLink';
import { useFields } from '@/routes/hooks/useFields';
import { BillSize } from '@/state/state.types';
import { RedirectToBookAppointmentButton } from './RedirectToBookAppointmentButton';
import { Calendar } from './icons/Calendar';

interface SalesBannerProps {
  stepId: string;
}
export const SalesBanner = ({ stepId }: SalesBannerProps) => {
  const fields = useFields();
  const hasScheduledCall = fields?.['offer-consult'];
  const billSize = BillSize.parse(fields?.['bill-size']);
  const isBillSizeOver15k = [
    BillSize.Enum['15k-50k'],
    BillSize.Enum['50k-250k'],
    BillSize.Enum['more-than-250k'],
    BillSize.Enum['5k-15k'],
  ].includes(billSize);

  const consultationLink = useConsultationLink({ stepId });

  return (
    <>
      {hasScheduledCall !== 'yes' && (
        <>
          <Flex
            align="center"
            h={25}
          ></Flex>
          <Flex
            align="center"
            justify="center"
            mt={10}
          >
            <RedirectToBookAppointmentButton
              appointmentUrl={consultationLink}
              stepId={stepId}
              shouldOpenCallingApp={!isBillSizeOver15k}
              radius="3.125rem"
              px={20}
              py={8}
              styles={(theme) => ({
                root: {
                  border: `1px solid ${theme.colors.primary[0]}`,
                },
              })}
            >
              <Group
                spacing={7}
                align="center"
              >
                <Calendar color="black" />
                <Text
                  c="primary.0"
                  fw={700}
                  fz="sm"
                >
                  Schedule a free consult
                </Text>
              </Group>
            </RedirectToBookAppointmentButton>
          </Flex>
        </>
      )}
    </>
  );
};
